interface AppConfig {
	API_URL: string;
}
let config: AppConfig;

switch (process.env.REACT_APP_ENV) {
	case 'test':
		config = require('./config.test').default;
		break;
	case 'prod':
		config = require('./config.prod').default;
		break;
	default:
		config = require('./config.dev').default;
		break;
}

export default config;